import { render } from "./ProjectManage.vue?vue&type=template&id=3284dbbd&scoped=true"
import script from "./ProjectManage.vue?vue&type=script&lang=js"
export * from "./ProjectManage.vue?vue&type=script&lang=js"

import "./ProjectManage.vue?vue&type=style&index=0&id=3284dbbd&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3284dbbd"]])

export default __exports__